import { TeamOutlined } from '@ant-design/icons';
import appIcon from '@assets/images/icons/App.svg';
import auditLogIcon from '@assets/images/icons/Audit log.svg';
import buIcon from '@assets/images/icons/BU icon.svg';
import cloudIcon from '@assets/images/icons/Cloud.svg';
import companyIcon from '@assets/images/icons/Company.svg';
import costCenterIcon from '@assets/images/icons/Cost center.svg';
import logIcon from '@assets/images/icons/Log icon.svg';
import logoIcon from '@assets/images/icons/logo.svg';
import menuIcon from '@assets/images/icons/menu.svg';
import roleIcon from '@assets/images/icons/Role icon.svg';
import userIcon from '@assets/images/icons/User.svg';
import identityIcon from '@assets/images/icons/identity-logo-link.svg';
import expenseIcon from '@assets/images/icons/expense-logo-link.svg';
import safeIcon from '@assets/images/icons/safe-logo-link.svg';
import onboardIcon from '@assets/images/icons/onboard-logo-link.svg';
import React from 'react';

export const SIDEBAR_MENU = [
	{
		id: 'User-Area',
		text: 'User Area',
		icon: <TeamOutlined />,
		visible: true,
		userType: 'CUSTOMER',
		children: [
			{
				text: 'Cloud Account',
				url: '/user-area/cloud-accounts/aws',
				key: '1',
				icon: cloudIcon,
				visible: true,
			},
			{
				text: 'User',
				url: '/user-area/users',
				key: '2',
				icon: userIcon,
				visible: false,
			},
			{
				text: 'Business Unit',
				url: '/user-area/business-units',
				key: '3',
				icon: buIcon,
				visible: false,
			},
			{
				text: 'Cost Center',
				url: '/user-area/cost-center',
				key: '4',
				icon: costCenterIcon,
				visible: false,
			},
			{
				text: 'Role',
				url: '/user-area/role',
				key: '5',
				icon: roleIcon,
				visible: false,
			},
			{
				text: 'Log',
				url: '/user-area/log',
				key: '6',
				icon: logIcon,
				visible: false,
			},
		],
	},
	{
		id: 'Admin-Area',
		text: 'Admin Area',
		icon: <TeamOutlined />,
		visible: false,
		userType: 'ADMIN',
		children: [
			{
				text: 'User Management',
				url: '/admin-area/user',
				key: '1',
				icon: userIcon,
				visible: false,
			},
			{
				text: 'Company',
				url: '/admin-area/company',
				key: '2',
				icon: companyIcon,
				visible: false,
			},
			{
				text: 'Application',
				url: '/admin-area/application',
				key: '3',
				icon: appIcon,
				visible: false,
			},
			{
				text: 'Role',
				url: '/admin-area/role',
				key: '4',
				icon: roleIcon,
				visible: false,
			},
			{
				text: 'Audit Log',
				url: '/admin-area/audit-log',
				key: '5',
				icon: auditLogIcon,
				visible: false,
			},
		],
	},
];

export const MENU_NAVIGATION = [
	{
		id: 'expense',
		text: 'Cloud Expense',
		icon: expenseIcon,
		url: process.env.REACT_APP_EXPENSE,
	},
	{
		id: 'security',
		text: 'Cloud Safe',
		icon: safeIcon,
		url: process.env.REACT_APP_SECURITY_ASSURANCE,
	},
	{
		id: 'identity',
		text: 'Cloud Identity',
		icon: identityIcon,
		url: process.env.REACT_APP_IDENTITY,
	},
];
